import { memo } from 'react'

import { PositionMap } from '@Store/types/index'

interface PositionBarProps {
  position: keyof typeof PositionMap
}

const POSITION_BAR_TILE_COUNT = 5
const AVERAGE_POSITION = Math.ceil(POSITION_BAR_TILE_COUNT / 2)

function PositionBar({ position }: PositionBarProps): JSX.Element {
  const filledCount =
    position === null ? 0 : POSITION_BAR_TILE_COUNT - position + 1
  const fillColor =
    filledCount === 0
      ? 'bg-gray-300'
      : filledCount === AVERAGE_POSITION
        ? 'bg-orange-400'
        : filledCount > AVERAGE_POSITION
          ? 'bg-green-100'
          : 'bg-red-500'

  return (
    <>
      <h1 className="text-center font-medium text-lg text-gray-900 leading-7">
        Position:
        <span className="ml-1">{PositionMap[position]}</span>
      </h1>
      <div className="flex items-center space-x-2">
        {Array.from({ length: POSITION_BAR_TILE_COUNT }).map((_, index) => (
          <div
            key={index}
            className={`w-6 xl:w-[26px] xxl:w-8 h-3 xl:h-4 rounded-md ${
              position === null
                ? 'border border-gray-300 bg-transparent'
                : index < filledCount
                  ? fillColor
                  : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </>
  )
}

const MemoPositionBar = memo(PositionBar)

export default MemoPositionBar
